import React from 'react'
import { makeStyles } from '@material-ui/core'
import { HashLink as Link } from 'react-router-hash-link';
import { classNames } from '../functions';

const useStyles = makeStyles((theme) => ({
    link: {
        textDecoration: 'none',
        color: theme.palette.text.primary,
        transition: 'all 0.2s ease-in',
        '&:hover': {
            color: `${theme.palette.primary.main}`,
        }
    },
    insideHover: {
        '& p': {
            transition: 'all 0.2s ease-in',
        },
        '&:hover': {
            '& *': {
                color: `${theme.palette.primary.main}`,
            }
        }
    }
}))

const LinkComponent = ({ to, className = '', textInside, children, external_link, title, download }) => {
    const classes = useStyles();

    return (
        <>
            {external_link
                ? <a className={classNames([classes.link, textInside ? classes.insideHover : '', className])} href={to} download={download} target="_blank" rel="noreferrer" title={title}>{children}</a>
                : <Link className={classNames([classes.link, textInside ? classes.insideHover : '', className])} to={to} title={title} >{children}</Link>
            }
        </>
    )
}

export default React.memo(LinkComponent);